export default __webpack_public_path__ + "static/media/reglogin-bg-cn.60beff44.webp";